<template>
  <a
    v-if="external"
    :href="disabled ? undefined : (to as string)"
    :class="[variantClass, disabled && 'disabled']"
    :aria-disabled="disabled || undefined"
    @click="disabled && $event.preventDefault()"
  >
    <slot />
  </a>

  <RouterLink
    v-else
    :to="to"
    :active-class="activeClass"
    :exact-active-class="exactActiveClass"
    :class="[variantClass, disabled && 'disabled']"
    :aria-disabled="disabled || undefined"
    @click="disabled && $event.preventDefault()"
  >
    <slot />
  </RouterLink>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { RouteLocationAsPathGeneric, RouteLocationAsRelativeGeneric } from 'vue-router'

const props = withDefaults(
  defineProps<{
    to: string | RouteLocationAsRelativeGeneric | RouteLocationAsPathGeneric
    external?: boolean
    variant?: 'default' | 'muted' | 'nav' | 'button'
    disabled?: boolean
    activeClass?: string
    exactActiveClass?: string
  }>(),
  {
    variant: 'default',
    disabled: false,
    external: false,
    activeClass: undefined,
    exactActiveClass: undefined,
  },
)

const variantClass = computed(() => {
  switch (props.variant) {
    case 'muted':
      return 'underline underline-offset-4'
    case 'nav':
      return 'rounded-md px-3 py-1.5 transition-colors'
    case 'button':
      return 'rounded-md px-3 py-1.5 transition-colors'
  }
  // default
  return 'underline underline-offset-4'
})
</script>
<style scoped lang="scss">
.disabled {
  pointer-events: none;
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
